import Config from 'netxcore@netx/core-category/config';

Object.assign(Config, {
	//ASSET_LIST_FACETED: true,
	MODAL: true, // the category editor window can be modal or full-screen
	/*
	 * TREE_MAX_DEPTH: 1
	 * tree: true,
	 * displayCategoriesAsAssets: true
	 * categoryid: 9
	 */
});

export default Config;
